// The books' fonts at the weights the books render (R-25, RULES §UI-8), self-hosted.
import '@fontsource/space-grotesk/400.css';
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import '@/ui/tokens.css';
import '@/styles/global.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createAppRouter } from '@/app/router';
import { initialLocale, loadLocale, setLocale, useLocale } from '@/lib/i18n';
import { createQueryClient } from '@/lib/queryClient';
import { TooltipProvider } from '@/ui';

// Dev only: `?mock` serves invented data without a server or sign-in (src/dev/mock.ts).
if (import.meta.env.DEV) {
  const mock = await import('./dev/mock');
  if (mock.mockRequested()) mock.installMock();
}

await loadLocale(initialLocale());
setLocale(initialLocale());
document.documentElement.lang = initialLocale();

const queryClient = createQueryClient();
const router = createAppRouter(queryClient);

function App() {
  // Re-render every t() call when the language changes.
  const locale = useLocale();
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <RouterProvider key={locale} router={router} />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
